// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,body{background-color:#343D46}body{color:white;font-size:16px;font-family:Helvetica, Arial}\n", ""]);
// Exports
module.exports = exports;
